import { Flex } from 'antd';
import { useTranslation } from 'translations/hooks';

import { RingComplianceStatus } from 'business/quality-control/pages/ring-compliance-report/hooks/data/types';
import { RingValidationDetailV1OutputDto } from 'generated/apiSchemas';

import { SegmentDetails } from './segment-details';

export const RingComplianceBody = ({
  detail,
}: {
  detail: RingValidationDetailV1OutputDto;
}) => {
  const { t } = useTranslation();

  if (
    ![
      RingComplianceStatus.Compliant,
      RingComplianceStatus.Approved,
      RingComplianceStatus.Refused,
    ].includes(detail.status as RingComplianceStatus)
  ) {
    return (
      <Flex justify="center">
        <p>{t('qualityControl.ringComplianceReport.detail.notReady')}</p>
      </Flex>
    );
  }

  const sortedSegments = [...(detail.segments ?? [])].sort((first, second) =>
    first.segmentType.localeCompare(second.segmentType),
  );

  return (
    <Flex vertical gap={12}>
      {sortedSegments.map((segment) => (
        <SegmentDetails
          key={segment.segmentType}
          label={segment.segmentType}
          defects={segment.defects}
          mold={segment.mold}
          manufactureDate={segment.manufactureDate}
          serialNumber={segment.serialNumber}
        />
      ))}
    </Flex>
  );
};
